import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Avatar, Typography, Divider } from "@material-ui/core";
import SwapHorizontalCircleRoundedIcon from "@material-ui/icons/SwapHorizontalCircleRounded";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.primary,
    fontSize: "0.9rem",
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: "white",
  },
  rowBottom: {
    marginBottom: "1rem",
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginTop: "0.3rem",
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  subtitle2: {
    color: theme.palette.text.secondary,
    textAlign: "left",
  },
  emphasize: {
    fontWeight: "bold",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
}));

const OrderEditRefunded = () => {
  const classes = useStyles();
  const { order } = useContext(OrderContext);
  const [payment, setPayment] = useState({});
  const [title, setTitle] = useState();

  useEffect(() => {
    // Discount (label, price)
    let discount = [];

    if (order.discount_codes) {
      order.discount_codes.map((each) => {
        discount.push({
          code: each.code,
          amount: each.amount,
        });
      });
    }

    // Subtotal Price (qty, price)
    let quantity = 0;
    let subtotal_price = 0;

    order.line_items.map((each) => {
      quantity += each.quantity;
    });

    if (order.subtotal_price) {
      subtotal_price = order.subtotal_price;
    }

    // Shipping Fee (label, price)
    let shipping_title = "";
    let shipping_price = "0.00";

    if (order.shipping_lines.length > 0) {
      shipping_title = order.shipping_lines[0].title;
      shipping_price = order.shipping_lines[0].price;
    }

    // Total Price
    let total_price = 0;

    if (order.total_price) {
      total_price = order.total_price;
    }

    // Refunds
    let refunds_trx = [];
    let refunded = 0;

    order.refunds.map((each) => {
      let amounts = [];

      if (each.transactions.length === 0) {
        amounts.push("-");
      }

      each.transactions.map((trx) => {
        // [price, ...]
        amounts.push(trx.amount);
        // Accumulate Refund Amount
        refunded += parseFloat(trx.amount);
      });

      refunds_trx.push({
        note: each.note,
        amounts: amounts,
      });
    });

    // Net Payment
    const netpay = (
      parseFloat(order.total_price) - parseFloat(refunded)
    ).toFixed(2);

    setPayment({
      discount: discount,
      quantity: String(quantity),
      subtotal_price: String(subtotal_price),
      shipping_title: String(shipping_title),
      shipping_price: String(shipping_price),
      total_price: String(total_price),
      refunds: refunds_trx,
      netpay: String(netpay),
    });

    // Payment Title
    const replace_title = order.financial_status.replace("_", " ");
    const new_title =
      replace_title.charAt(0).toUpperCase() + replace_title.slice(1);
    setTitle(new_title);
  }, [order]);

  return (
    Object.keys(payment).length === 8 && (
      <Grid
        container
        direction="column"
        alignitem="center"
        justifyContent="flex-start"
      >
        <Paper className={classes.paper}>
          <Grid spacing={1} container className={classes.rowBottom}>
            {" "}
            {/* Title */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="flex-start"
              className={classes.rowBottom}
            >
              <Grid item>
                <Avatar
                  className={classes.avatar}
                  style={{
                    backgroundColor: "green",
                  }}
                >
                  <SwapHorizontalCircleRoundedIcon />
                </Avatar>{" "}
              </Grid>{" "}
              & ensp;{" "}
              <Grid item>
                <Typography variant="body1" className={classes.title}>
                  {" "}
                  {title}{" "}
                </Typography>{" "}
              </Grid>{" "}
            </Grid>
            {/* Discount */}{" "}
            {payment.discount.map((discount, discount_index) => {
              return (
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  alignitem="center"
                  justifyContent="space-between"
                >
                  <Grid item xs={1} container justifyContent="flex-start">
                    {" "}
                    {discount_index === 0 ? "Discount" : ""}{" "}
                  </Grid>{" "}
                  <Grid
                    item
                    xs={9}
                    container
                    justifyContent="flex-start"
                    className={classes.subtitle}
                  >
                    & ensp; {discount.code}{" "}
                  </Grid>{" "}
                  <Grid item xs={2} container justifyContent="flex-end">
                    -$ {discount.amount}{" "}
                  </Grid>{" "}
                </Grid>
              );
            })}
            {/* Subtotal */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="space-between"
            >
              <Grid item xs={1} container justifyContent="flex-start">
                Subtotal{" "}
              </Grid>{" "}
              <Grid
                item
                xs={9}
                container
                justifyContent="flex-start"
                className={classes.subtitle}
              >
                & ensp; {payment.quantity}
                items{" "}
              </Grid>{" "}
              <Grid item xs={2} container justifyContent="flex-end">
                $ {payment.subtotal_price}{" "}
              </Grid>{" "}
            </Grid>
            {/* Shipping */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="space-between"
            >
              <Grid item xs={1} container justifyContent="flex-start">
                Shipping{" "}
              </Grid>{" "}
              <Grid
                item
                xs={9}
                container
                justifyContent="flex-start"
                className={classes.subtitle}
              >
                & ensp; {payment.shipping_title}{" "}
              </Grid>{" "}
              <Grid item xs={2} container justifyContent="flex-end">
                $ {payment.shipping_price}{" "}
              </Grid>{" "}
            </Grid>
            {/* Total */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="space-between"
            >
              <Grid item xs={1} container justifyContent="flex-start">
                Total{" "}
              </Grid>{" "}
              <Grid item xs={9} container justifyContent="flex-start">
                {" "}
              </Grid>{" "}
              <Grid item xs={2} container justifyContent="flex-end">
                $ {payment.total_price}{" "}
              </Grid>{" "}
            </Grid>
            <Grid item xs={12}>
              <Divider className={classes.divider} orientation="horizontal" />
            </Grid>
            {/* Paid By Customer */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="space-between"
            >
              <Grid item xs={2} container justifyContent="flex-start">
                Paid by customer{" "}
              </Grid>{" "}
              <Grid item xs={8} container justifyContent="flex-start">
                {" "}
              </Grid>{" "}
              <Grid item xs={2} container justifyContent="flex-end">
                $ {payment.total_price}{" "}
              </Grid>{" "}
            </Grid>
            <Grid item xs={12}>
              <Divider className={classes.divider} orientation="horizontal" />
            </Grid>
            {/* Refunds */}{" "}
            {payment.refunds.map((refund, refund_index) => {
              return (
                <Grid
                  key={refund_index}
                  item
                  xs={12}
                  container
                  direction="row"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Grid item xs={1} container justifyContent="flex-start">
                    {" "}
                    {refund_index === 0 && "Refunded"}{" "}
                  </Grid>{" "}
                  <Grid item xs={1}>
                    {" "}
                  </Grid>{" "}
                  <Grid
                    item
                    xs={8}
                    container
                    justifyContent="flex-start"
                    className={classes.subtitle2}
                  >
                    {`Reason: ${refund.note ? refund.note : "-"}`}{" "}
                  </Grid>{" "}
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="flex-end"
                    justifyContent="flex-end"
                  >
                    {refund.amounts.map((amount, index) => {
                      return (
                        <Grid item key={index}>
                          {" "}
                          {amount === "-" ? "-" : `-$${amount}`}{" "}
                        </Grid>
                      );
                    })}{" "}
                  </Grid>{" "}
                </Grid>
              );
            })}
            {/* Net Payment */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              className={classes.emphasize}
            >
              <Grid item xs={2} container justifyContent="flex-start">
                Net payment{" "}
              </Grid>{" "}
              <Grid item xs={8} container justifyContent="flex-start">
                {" "}
              </Grid>{" "}
              <Grid item xs={2} container justifyContent="flex-end">
                $ {payment.netpay}{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Paper>{" "}
      </Grid>
    )
  );
};

export default OrderEditRefunded;
